import { Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { headingBlue, maroon } from "../assets/colors";
import { useNavigate } from "react-router-dom";
import { Dashboard, SummarizeOutlined, Calculate } from "@mui/icons-material";
import { containerStyle, imgContainer, imgStyle } from "./formStyle";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import QuizIcon from '@mui/icons-material/Quiz';
import WORKslogans from "./WORKslogans";

var rowStyle = {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	color: headingBlue,
	curser: "pointer",
};

var headingStyle = {
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	wordWrap: "break-word",
	textAlign: "center",
	fontSize: "0.9rem",
};

const HomePage = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

	const navigate = useNavigate();

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth <= 768);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const gridColumnStyle = isMobile ? "repeat(1, 1fr)" : "repeat(4, 1fr)";

	return (
		<div style={{ ...containerStyle, maxWidth: "32rem", marginTop: "1rem" }}>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<WORKslogans />
			</div>
			<div style={imgContainer}>
				<img
					src={require("../assets/images/WORK_logo.png")}
					alt="Logo"
					style={imgStyle}
				></img>
			</div>
			<Paper
				style={{
					padding: "1.5rem 1.5rem 1.5rem 1.5rem",
				}}
			>
				<Grid container spacing={1} style={{display: 'flex', justifyContent: 'center', padding: '0rem 0rem 0.5rem 0rem'}}>
					<Grid item xs={4} sm={3}>
						<div
							style={{ ...rowStyle }}
							onClick={() => {
								const url = `${window.location.origin}/dsf`;
								window.open(url, "_blank", "noopener,noreferrer");
								// navigate("/reportForm")
							}}
							onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
							onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
						>
							<SummarizeOutlined sx={{ fontSize: "3rem" }} />
							{/* <h3 style={{ fontSize: isMobile ? "1.1rem" : "1.2rem" }}>Tasks</h3> */}
							<Typography style={headingStyle}>District Selection Form</Typography>
						</div>
					</Grid>
					<Grid item xs={4} sm={3}>
						<div
							style={{ ...rowStyle }}
							onClick={() => {
								const url = `${window.location.origin}/reportForm`;
								window.open(url, "_blank", "noopener,noreferrer");
								// navigate("/reportForm")
							}}
							onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
							onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
						>
							<SummarizeOutlined sx={{ fontSize: "3rem" }} />
							{/* <h3 style={{ fontSize: isMobile ? "1.1rem" : "1.2rem" }}>Tasks</h3> */}
							<Typography style={headingStyle}>WORKers Portal</Typography>
						</div>
					</Grid>
					<Grid item xs={4} sm={3}>
						<div
							style={rowStyle}
							onClick={() => {
								const url = `${window.location.origin}/dashboard`;
								window.open(url, "_blank", "noopener,noreferrer");
								// navigate("/dashboard")
							}}
							onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
							onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
						>
							<Dashboard sx={{ fontSize: "3rem" }} />
							{/* <h3 style={{ fontSize: isMobile ? "1.1rem" : "1.2rem" }}>Tasks</h3> */}
							<Typography style={headingStyle}>Dashboard</Typography>
						</div>

					</Grid>
				</Grid>

				<Divider></Divider>


				<Grid container spacing={1} style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-end', padding: '0.5rem 0rem 0rem 0rem'}}>
					<Grid item xs={4} sm={3}>
						<div
							style={rowStyle}
							onClick={() => {
								const url = `${window.location.origin}/content-sheet`;
								window.open(url, "_blank", "noopener,noreferrer");
								// navigate("/dashboard")
							}}
							onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
							onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
						>
						<DescriptionOutlinedIcon sx={{ fontSize: "3rem" }} />
						<Typography style={headingStyle}>Daily Task Content Sheet</Typography>
					</div>

					</Grid>
					<Grid item xs={4} sm={3}>
						<div
							style={rowStyle}
							onClick={() => {
								const url = `https://worktrust.in/inheritance_calculator`;
								window.open(url, "_blank", "noopener,noreferrer");
							}}
							onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
							onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
						>
						<Calculate sx={{ fontSize: "3rem" }} />
							<Typography style={headingStyle}>Inheritance Calculator</Typography>
						</div>

					</Grid>
					<Grid item xs={4} sm={3}>
						<div
							style={rowStyle}
							onClick={() => {
								const url = `${window.location.origin}/shareReferral`;
								window.open(url, "_blank", "noopener,noreferrer");
								// navigate("/dashboard")
							}}
							onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
							onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
						>
						<ConnectWithoutContactIcon style={{ fontSize: "3rem" }} />
						<Typography style={headingStyle}>Share <br></br> Referral</Typography>
					</div>

					</Grid>
					<Grid item xs={4} sm={3}>
						<div
							style={rowStyle}
							onClick={() => {
								const url = `${window.location.origin}/NRQuiz`;
								window.open(url, "_blank", "noopener,noreferrer");
								// navigate("/dashboard")
							}}
							onMouseOver={(e) => (e.currentTarget.style.color = maroon)}
							onMouseOut={(e) => (e.currentTarget.style.color = headingBlue)}
						>
						<QuizIcon style={{ fontSize: "2.5rem" }} />
						<Typography style={headingStyle}>Nabi-e-Rehmat <br></br> Quiz</Typography>
					</div>

					</Grid>

				</Grid>
			</Paper>
		</div>
	);
};

export default HomePage;
